import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconDeskGlobe({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.5 9.485a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.425 2.061A10.5 10.5 0 1 1 3.575 16.91M19.485 1l-1.06 1.061M3.575 16.91l-1.06 1.06M11 19.985v3M5 22.985h12" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.124 6.485H5.75a1.5 1.5 0 0 1 1.5 1.5v1.63a1.5 1.5 0 0 0 .439 1.06l1.155 1.155a1.5 1.5 0 0 1 .363 1.535l-.309.926a1.5 1.5 0 0 1-.523.725l-1.216.912M13.4 2.379c-.407.325-.841.662-1.226.959a1.5 1.5 0 0 0-.285 2.088l.911 1.209a1.5 1.5 0 0 0 1.2.6h.879a1.5 1.5 0 0 1 1.06.44l1.155 1.155a1.5 1.5 0 0 0 1.4.4" /></svg></>;
}
IconDeskGlobe.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconDeskGlobe;